<template>
  <dara-row class="d-flex align-items-center justify-content-center">
    <dara-col v-if="!add" :sm="24" :md="2">
      <dara-header size="sm" class="text-center">{{ index + 1 }}</dara-header>
    </dara-col>
    <dara-col :sm="24" :md="sizeCol">
      <div class="mb--sm">
        <dara-small>
          {{ createdAt }} {{ $t('by') }}
          <dara-user-link v-if="localArticle.user" :id="localArticle.user.id" target="_blank">
            {{ localArticle.user.name }} {{ localArticle.user.last_name }}
          </dara-user-link>
          •
        </dara-small>
        <dara-small class="color--success">{{ readingTime }}</dara-small>
      </div>
      <dara-p weight="strong">
        <dara-article-link :id="localArticle.id" :slug="localArticle.slug" target="_blank">
          {{ localArticle.title }}
        </dara-article-link>
        <small class="text-muted">
          ( {{ getArticleAccess(localArticle) }} )
        </small>
      </dara-p>
      <div class="mb--sm">
        <dara-small class="text-muted dara-u-text--small d-block">
          <strong>{{ $t('department') }}:</strong> {{ department }}
        </dara-small>
      </div>
    </dara-col>
    <dara-col :sm="24" :md="2">
      <div>
        <dara-icon v-if="!add" style="cursor: pointer" icon="trash" @click="removeArticle" />
        <dara-icon v-else style="cursor: pointer" icon="file-earmark-plus" @click="addArticle" />
      </div>
    </dara-col>
  </dara-row>
</template>

<script>
import { formatToTimeAgo } from '@/helpers/date/date';
import { getArticleById } from '@/modules/article/article.service';
import { translate } from '@/services/translate.service';
import { getDepartmentById } from '@/modules/department/department.service';
import { toastError } from '@/services/toastService';

import DaraArticleLink from '@/modules/article/components/ArticleLink.vue';
import DaraUserLink from '@/modules/user/components/UserLink.vue';

export default {
  name: 'ArticleCardList',
  components: {
    DaraArticleLink,
    DaraUserLink,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      default: null,
    },
    add: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      localArticle: this.article,
      sizeCol: 20,
      department: null,
    };
  },
  computed: {
    createdAt() {
      return `${formatToTimeAgo(this.localArticle.created_at)}`;
    },
    readingTime() {
      return `${this.localArticle.reading_time} ${translate('min-read')}`;
    },
  },
  mounted() {
    if (this.add) {
      this.sizeCol = 22;
    }
    this.fetch();
  },
  methods: {
    // TODO: remover funcção desnecessária, pois o article já vem via props. Entretanto, quando é pela tela de tracks ele não traz as informações do usuário (via props)
    fetch() {
      getArticleById(this.article.id)
        .then(({ data }) => {
          this.localArticle = data;
          this.getDepartment(this.localArticle.department_id);
        }).catch();
    },
    addArticle() {
      this.localArticle.order = this.index;
      this.$emit('addOrRemove', this.localArticle);
    },
    removeArticle() {
      this.$emit('addOrRemove', this.index);
    },
    getDepartment(department) {
      getDepartmentById(department)
        .then(data => {
          this.department = data.name;
        }).catch(() => {
          toastError(`${translate('error-getting-department')}`);
        });
    },
    getArticleAccess(article) {
      switch (article.access) {
      case 1:
        return this.department;
      case 2:
        return translate('private');
      default:
        return translate('public');
      }
    },
  },
};
</script>
